(function () {
  NodeList.prototype.forEach = Array.prototype.forEach;
  NodeList.prototype.filter = Array.prototype.filter;
})();
